//Limitless imports
import { useAuthenticationContext } from "../authentication/AuthenticationContext";
import { useExpertProfileContext } from "../expert-profile/ExpertProfileContext";
export const useSecurityProfileHook = () => {
  const {
    signOut
  } = useAuthenticationContext();
  const {
    securityProfileChanged
  } = useExpertProfileContext();
  const confirmChange = () => {
    signOut();
  };
  return {
    confirmChange,
    securityProfileChanged
  };
};